export default __webpack_public_path__ + "static/media/four.867877ba.jpg";